import { render, staticRenderFns } from "./MiniLoading.vue?vue&type=template&id=5bd94688&scoped=true&"
var script = {}
import style0 from "./MiniLoading.vue?vue&type=style&index=0&id=5bd94688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd94688",
  null
  
)

export default component.exports